<div class="container-fluid d-flex px-4 border-bottom">
    <div class="d-flex flex-fill align-items-center">
        <div class="me-2">
            <button
                sqHeaderToggler
                [sqSidebarToggle]="sidebarId()"
                toggle="visible"
                aria-label="Toggle navigation"
                class="btn header-toggler"
                style="margin-inline-start: -14px"
                type="button">
                <fa-icon [icon]="['fas', 'bars']"></fa-icon>
            </button>
        </div>
        <div>
            <sq-breadcrumb-router></sq-breadcrumb-router>
        </div>
        <div class="ms-auto">
            <div class="d-flex flex-row align-items-center">
                <!-- @if (appStore.isOnTrial() && appStore.trialEndDate()) {
                    <span class="badge text-bg-warning">On Trial</span>
                } -->
                @if (me()?.isImpersonating) {
                    <button
                        type="button"
                        class="btn btn-danger btn-sm fw-bold d-inline-flex align-items-center"
                        (click)="stopImpersonation()"
                        title="Stop Impersonation">
                        <fa-icon class="d-flex align-items-center me-1" [icon]="['fas', 'times-circle']"> </fa-icon>
                        <span>Stop Impersonating</span>
                    </button>
                }

                <button
                    type="button"
                    class="btn btn-link text-decoration-none d-flex align-items-center gap-2"
                    (click)="openUserProfile()">
                    <fa-icon [icon]="['fas', 'user-circle']" class="fs-5"></fa-icon>
                    <span>{{ me()?.firstName }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
